var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Self-Employment",
    clipPath: "url(#clip0_5830_836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0967 5.58915C10.5322 6.0247 11.0556 6.24248 11.6667 6.24248C12.277 6.24322 12.8 6.02581 13.2356 5.59026C13.6711 5.1547 13.8889 4.63137 13.8889 4.02026C13.8896 3.40989 13.6722 2.88693 13.2367 2.45137C12.8011 2.01581 12.2778 1.79803 11.6667 1.79803C11.0563 1.7973 10.5333 2.0147 10.0978 2.45026C9.66222 2.88581 9.44444 3.40915 9.44444 4.02026C9.4437 4.63063 9.66111 5.15359 10.0967 5.58915Z",
    fill: "#14AA3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 9.29804V11.798H15V9.02026C15.0007 8.55804 14.8389 8.1647 14.5144 7.84026C14.19 7.51581 13.7963 7.35359 13.3333 7.35359H10C9.16593 7.35285 8.44815 7.08878 7.84667 6.56137C7.24518 6.03396 6.87037 5.37211 6.72222 4.57581H4.5C4.61111 5.68692 5.01852 6.66841 5.72222 7.52026C6.42593 8.37211 7.2963 8.9647 8.33333 9.29804Z",
    fill: "#14AA3C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3891 21.2425H2.61133",
    stroke: "#6E6E6E",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.61133 23.0202V12.3536H20.3891V23.0202",
    stroke: "#6E6E6E",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.833496 12.3536H22.1668",
    stroke: "#6E6E6E",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5830_836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.1111,
    fill: "white",
    transform: "translate(-0.5 0.798035)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario2);
export default __webpack_public_path__ + "static/media/Scenario2.601eeec95d829b828e49713bcbdd1599.svg";
export { ForwardRef as ReactComponent };